import dayjs from 'dayjs'
import { ShippingAddress } from '../typings/base'
import { ORDER_ITEM_TYPE, ORDER_STATE } from './constants'

//get order informations
export const getOrderInformations = (
  order: any,
  index: number,
  numberOfOrders: number
) => {
  let state: string
  const orderStartLeasingDate: string = order.startLeasingDate
  const orderEndLeasingDate: string = order.endLeasingDate
  const isCancelled: boolean = order.shippingState === ORDER_STATE.CANCELLED
  const shippingAddress: ShippingAddress = order.shippingAddress
  const currentDate = dayjs()
  const startLeasingDate = dayjs(order.startLeasingDate, 'DD/MM/YYYY')
  const endLeasingDate = dayjs(order.endLeasingDate, 'DD/MM/YYYY')
  const checkoutCompletedAt = dayjs(order.checkoutCompletedAt).format(
    'DD/MM/YYYY'
  )
  const lastOrder: boolean = index + 1 === numberOfOrders
  const isCancellable: boolean = order.isCancellable
  const tokenValue: string = order.tokenValue
  const cancelledAt = order.cancelledAt
  const shipments = order.shipments
  const total = order.totals?.total

  if (isCancelled) {
    state = ORDER_STATE.CANCELLED
  } else {
    if (currentDate.diff(startLeasingDate, 'day') <= 0) {
      state = ORDER_STATE.COMING
    } else if (currentDate.diff(endLeasingDate, 'day') <= 0) {
      state = ORDER_STATE.RETURN
    } else {
      state = ORDER_STATE.FINISHED
    }
  }
  const rentalOrderList: any = order.items.filter(
    (item) => item.type === ORDER_ITEM_TYPE.RENTAL
  )
  const secondHandOrderList: any = order.items.filter(
    (item) => item.type === ORDER_ITEM_TYPE.SECOND_HAND
  )
  return {
    orderNumber: order.number,
    rentalOrderList,
    secondHandOrderList,
    isCancelled,
    state,
    orderStartLeasingDate,
    orderEndLeasingDate,
    shippingAddress,
    checkoutCompletedAt,
    lastOrder,
    isCancellable,
    tokenValue,
    cancelledAt,
    shipments,
    total,
  }
}

// handle second hand product selection

export const handleProductSelection = (
  Sku,
  id,
  quantity,
  token,
  item,
  setProductSelection,
  setProductToReturn,
  productToReturn,
  orderNumber?: string,
  warehouseId?: string,
  carrierId?: number
) => {
  setProductSelection(true)
  const productSelectionArray = [...productToReturn]

  // we first check if the product selected is already in the array of selected products
  if (productToReturn.find((product) => product.id === id)) {
    // if it is true the we remove the row in the array and we adapt the prices
    const index = productToReturn.findIndex((product) => product.id === id)
    productSelectionArray.splice(index, 1)
    // if nothing selected, disable generate button
    setProductSelection(productSelectionArray.length !== 0)
  } else {
    // if it is false we push a new row in the array of selected products and we adapt the prices
    productSelectionArray.push({
      id: id,
      Sku: Sku,
      expand: true,
      product: item.variant,
      quantity: quantity,
      orderToken: token,
      orderNumber: orderNumber,
      warehouseId: warehouseId,
      carrierId: carrierId,
    })
  }
  setProductToReturn(productSelectionArray)
}

// return second hand product

export const sendProductsToReturn = async (
  setIsDownloadLoading,
  productToReturn,
  user,
  postProductToReturn,
  setDownloadLink,
  downloadURI
) => {
  // we prepare the data to send, the send it and check if response is ok, then we download the recieved file
  setIsDownloadLoading(true)

  const productData = productToReturn.map((product) => ({
    lizeeSKU: product.Sku,
    quantity: product.quantity,
    orderToken: product.orderToken,
  }))

  const products = {
    products: productData,
    gender: user?.user?.gender,
    warehouseId: productToReturn[0].warehouseId,
    carrierId: productToReturn[0].carrierId,
    omsOrderId: productToReturn[0].orderNumber,
    rightOfWithdrawal: true,
  }

  const data = await postProductToReturn(products)
  if (data.type === 'POST_PRODUCT_TO_RETURN_SUCCESS') {
    if (data?.response[0]?.pdfUrl) {
      await setDownloadLink(data?.response[0]?.pdfUrl)
      await downloadURI(
        data.response[0].pdfUrl,
        `${process.env.STORE}_${data.response[0].trackingCode}`
      )
      await setIsDownloadLoading(false)
    }
  } else {
    setIsDownloadLoading(false)
  }
}
